/*!
 * Copyright © 2026 Nail Alliance - North America, Inc.
 * Authors: See snippets/copyright-notices.liquid in the theme.
 * No other use is authorized without a written contract.
 */

if(!customElements.get('navigation-videos')) customElements.define('navigation-videos',class extends HTMLElement{
  async connectedCallback(){
    this.controller=new AbortController(); const signal=this.controller.signal;
    try{
      const response=await fetch(this.dataset.source,{signal});if(!response.ok)throw new Error();this.data=await response.json();
      this.status=this.querySelector('[data-video-status]');this.status.hidden=true;
      this.data.categories.forEach(category=>{
        const button=document.createElement('button');button.type='button';button.dataset.category=category.key;
        const img=document.createElement('img');img.src=new URL(category.image,new URL(this.dataset.source,document.baseURI)).href;img.alt='';img.width=80;img.height=80;img.loading='lazy';
        const label=document.createElement('span');label.textContent=category.name;button.append(img,label);
        button.addEventListener('click',()=>this.selectCategory(category.key),{signal});this.querySelector('[data-categories]').append(button);
      });
      const seasons=this.querySelector('[data-collection]');Object.keys(this.data.videos.collections||{}).forEach(key=>seasons.add(new Option(key.replaceAll('-',' '),key)));
      seasons.addEventListener('change',()=>this.selectCategory('collections'),{signal});
      this.selectCategory(this.data.categories[0].key);
    }catch(error){if(error.name!=='AbortError')this.querySelector('[data-video-status]').textContent='The video library could not load. Please refresh to try again.';}
  }
  selectCategory(key){
    const isCollections=key==='collections';this.querySelector('[data-collection-picker]').hidden=!isCollections;
    const playlist=isCollections?this.data.videos.collections[this.querySelector('[data-collection]').value]:this.data.videos[key];
    const region=this.querySelector('[data-playlist]');region.replaceChildren();
    this.querySelectorAll('[data-category]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.category===key)));
    for(const video of playlist||[]){
      if(!/^[\w-]{11}$/.test(video.code))continue;
      const button=document.createElement('button');button.type='button';button.dataset.video=video.code;
      const image=document.createElement('img');image.src=`https://i.ytimg.com/vi/${video.code}/hqdefault.jpg`;image.alt='';image.width=480;image.height=360;image.loading='lazy';
      const label=document.createElement('span');label.textContent=video.name;button.append(image,label);
      button.addEventListener('click',()=>this.play(video),{signal:this.controller.signal});region.append(button);
    }
    if(playlist?.length)this.play(playlist[0]);
  }
  play(video){this.querySelector('[data-player]').src=`https://www.youtube-nocookie.com/embed/${video.code}`;this.querySelector('[data-player]').title=video.name;this.querySelector('[data-video-title]').textContent=video.name;this.querySelectorAll('[data-video]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.video===video.code)));}
  disconnectedCallback(){this.controller?.abort();}
});
